import type { FC } from "react";

import type { SupportedLanguage } from "@ryde/shared";

import { ErrorBoundaryLanguageSwitcherStyled } from "./error-boundary-language-switcher.styled";
import type { IErrorBoundaryTexts } from "./error-boundary.models";

interface IErrorBoundaryLanguageSwitcherProps {
  locale: SupportedLanguage;
  texts: IErrorBoundaryTexts;
  onLocaleChange: (locale: SupportedLanguage) => void;
}

export const ErrorBoundaryLanguageSwitcher: FC<
  IErrorBoundaryLanguageSwitcherProps
> = ({ locale, texts, onLocaleChange }) => (
  <ErrorBoundaryLanguageSwitcherStyled
    role="group"
    aria-label={texts.languageSwitcher}
  >
    <button
      type="button"
      className="error-boundary-language__button"
      lang="en"
      aria-label={texts.languageEnglish}
      aria-pressed={locale === "en"}
      onClick={() => onLocaleChange("en")}
    >
      EN
    </button>
    <button
      type="button"
      className="error-boundary-language__button"
      lang="he"
      aria-label={texts.languageHebrew}
      aria-pressed={locale === "he"}
      onClick={() => onLocaleChange("he")}
    >
      עב
    </button>
  </ErrorBoundaryLanguageSwitcherStyled>
);
